export const randomHashId = () => {
  return Math.random().toString(16).substring(2) 
}